export const getNumberOfDigits = (price: number) => (price % 1 !== 0 ? 2 : 0);
